import { GatsbyImage } from 'gatsby-plugin-image';
import React, { FC } from 'react';
import { Blocks } from '../../ui/blocks/Blocks';
import * as styles from './ArticleAuthor.module.scss';

interface Props {
  authorName?: string | null;
  authorInfos: string;
  authorPhoto: any;
}

const AuthorPhoto: FC<{ photo: any }> = ({ photo }) => {
  if (photo) {
    return (
      <div className={styles.authorPhoto}>
        <GatsbyImage className={styles.authorPhoto} image={photo} objectFit="cover" alt="logo" />
      </div>
    );
  } else {
    return (
      <div className={styles.authorPhoto}>
        <img className={styles.authorPhoto} src="/svg/portraitPlaceHolder.svg"></img>
      </div>
    );
  }
};

const ArticleAuthor: FC<Props> = ({ authorName, authorInfos, authorPhoto }) => {
  return (
    <>
      <div className={styles.authorWrapper}>
        <AuthorPhoto photo={authorPhoto} />
        <div className={styles.authorTextBox}>
          <div className={styles.authorName}>{authorName}</div>
          <div className={styles.authorInfos}>
            <Blocks blocks={authorInfos} />
          </div>
        </div>
      </div>
    </>
  );
};
export default ArticleAuthor;
